<div class="topline">
  <h1>Agency</h1>

  @if (agencies.length > 0) {
    <mat-form-field appearance="outline">
      <mat-label>Current Agency</mat-label>
      <mat-select
        [(value)]="selectedAgencyId"
        (selectionChange)="setAgencyId($event.value)">
        @for (agency of agencies; track agency) {
          <mat-option [value]="agency.id">
            {{ agency.name }} ({{ agencyClientCounts[agency.id] || 0 }})
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (agencies.length === 0) {
    <h1>
      {{ agencyName }}
    </h1>
  }
</div>

<app-infoband [items]="info"></app-infoband>

<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a
      mat-tab-link
      (click)="gotoTab(link)"
      [active]="activeLink?.title === link.title">
      {{ link.title }}
    </a>
  }
</nav>

<!-- No agency selected -->
@if (!selectedAgencyId) {
  <app-inlinemessage
    level="info"
    message="Please select an agency so that you can update their profile, members, and producers">
  </app-inlinemessage>
}

<!-- Agency selected -->
@if (selectedAgencyId) {
  @if (activeLink?.title === 'Profile') {
    <app-agency-profile
      [companyId]="selectedAgencyId">
    </app-agency-profile>
  }
  @if (activeLink?.title === 'Clients') {
    <app-agency-clients
      [companyId]="selectedAgencyId"
      [enabled]="true"
      (countEvent)="setCount('Clients', $event)">
    </app-agency-clients>
  }
  @if (activeLink?.title === 'Members') {
    <app-agency-members
      [companyId]="selectedAgencyId"
      [enabled]="true"
      (countEvent)="setCount('Members', $event)">
    </app-agency-members>
  }
  @if (activeLink?.title === 'Producers') {
    <app-agency-producers
      [companyId]="selectedAgencyId"
      [enabled]="true"
      (countEvent)="setCount('Producers', $event)">
    </app-agency-producers>
  }
}

<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
